import Main from "../../common/Main/Main";
import Loadspinner from "../../common/Loadspinner";
import { Link, useParams } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import Decrypt2 from "../../helpers/Cryptography/CryptoJS";
import notify from "../../ReusableComponents/ToastNotification/ToastNotification";
import { APICall } from "../../helpers/API/APICalls";
import { AppBar, Avatar, Box, Card, CardContent, CardMedia, Chip, Dialog, Divider, IconButton, Paper, Tab, Tabs, useTheme } from "@mui/material";
import { downloadBlob } from "../../services/CommonService";
import { Typography } from "@material-ui/core";
import DataCards2, { ShowAttachment } from "../../common/DataCards2/DataCards2";
import PropTypes from "prop-types";
import { format } from "date-fns";
import CloseIcon from "@mui/icons-material/Close";
import { getKnowledgeBaseMasterDataById, getAllknowledgeBasePost } from "../../helpers/API/APIEndPoints";
import * as images from "../../constants/Images";
import { getFromEncLocalStorage, replaceImgAccountName, storeInEncLocalStorage } from "../../helpers/Utils/Utils";
import { getAllKnowledgeBaseDataById } from "../../constants/ApiEndpoints";
import AsideCards from "../../common/AsideCards/AsideCards";
import "./KnowledgeBaseById.css";
import { Modal } from "react-bootstrap";
import AskQuery from "../QAndA/AskAnExpert/AskQuery";
import { Encrypt } from "../../helpers/Cryptography/CryptoJS";
import CommonConstants from "../../constants/CommonConstants";
import { Redirect } from "react-router";

const KnowldegeBaseaId = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [postData, setPostData] = useState([]);
  const [questionData, setQuestionData] = useState([]);
  const [bookmarksData, setBookmarksData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [isPostMore, setPostMore] = useState(false);
  const [isQuestionMore, setQuestionMore] = useState(false);
  const [isBookmarksMore, setBookmarksMore] = useState(false);
  const [isSearchMore, setSearchMore] = useState(false);
  const theme = useTheme();
  const [tabIndex, setTabIndex] = useState(0);
  const [kbId, setKbId] = useState(0);
  const [isBookmarkClicked, setBookmarkClicked] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [uploadQue, setUploadQue] = useState(false);
  const [details, showDetail] = useState(false);
  const [detailId, setDetail] = useState("");
  const [isKnowledge, setKnowledge] = useState(false);

  const KnowledgeBaseDataType = {
    Posts: 1,
    Questions: 2,
    Bookmarks: 3,
    Search: 4,
  };

  let state_id = 0;
  useEffect(() => {
    (async () => {
      state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      setKbId(state_id);
      if (state_id != 0 || state_id != "0") {
        getKnowledgeBaseMasterDataByIdApiCall(state_id);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      setFeedsData(KnowledgeBaseDataType.Posts, 1);
      setFeedsData(KnowledgeBaseDataType.Questions, 1);
      setFeedsData(KnowledgeBaseDataType.Bookmarks, 1);
    })();
  }, []);

  useEffect(() => {
    if (isBookmarkClicked) {
      setFeedsData(KnowledgeBaseDataType.Bookmarks, 1, false);
      setBookmarkClicked(false);
    }
  }, [isBookmarkClicked]);

  useEffect(() => {
    (async () => {
      if (searchText) {
        setTabIndex(2);
        setSearchFeedData(1);
      } else {
        setTabIndex(0);
        setSearchData([]);
      }
    })();
  }, [searchText]);

  const getKnowledgeBaseMasterDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(getKnowledgeBaseMasterDataById, { id: id }, "POST");

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].Id) {
        data.data[0][0].BackgroundImage = await downloadBlob(data.data[0][0].BackgroundImage);
        data.data[0][0].ProfileImage = await downloadBlob(data.data[0][0].ProfileImage);
        setData(data.data[0][0]);
        // console.log(data,"iddata")
      }

      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const getFeedsFromApi = async (type, page) => {
    const pageStart = (page - 1) * 10;
    let data = [];
    data.totalCount = 0;
    state_id = await Decrypt2(getFromEncLocalStorage("tokennumber"));
    let userId = getFromEncLocalStorage("employeenumber");
    let requestParams = {
      knowledgeBaseId: state_id,
      dataTypeId: type, //posts = 1, question = 2, bookmarks = 3
      start: pageStart,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: "",
      sortDirection: "",
      userId: userId,
    };
    let res = await APICall(getAllKnowledgeBaseDataById, requestParams);
    if (res.message === "Ok") {
      if (res && res.data.length > 0 && res.totalCount > 0) {
        for (let index = 0; index < res?.data?.length; index++) {
          const res1 = res?.data?.[index];
          res1.attachment = replaceImgAccountName(res1?.attachment);

          res1.bookmarked_histories = [];
          res1.likes_histories = [];
          res1.comment_data = [];
        }
        data = res.data;
        data.totalCount = res.totalCount;
      }
    }
    // let scrollPosition = getFromEncLocalStorage("position");
    // window.scrollTo(0, scrollPosition);

    return data;
  };

  const setFeedsData = async (type, page, showLoader = true) => {
    if (showLoader) setLoading(true);
    let data = await getFeedsFromApi(type, page);
    //if (data.length > 0) {
    let DataLength = 0;
    let TotalCount = data?.totalCount || 0;
    let respDataLength = data?.length || 0;
    let postLength = postData?.length || 0;
    let questionLength = questionData?.length || 0;
    let bookmarksLength = bookmarksData?.length || 0;
    switch (type) {
      default:
      case KnowledgeBaseDataType.Posts:
        setPostData(data);
        DataLength = postLength + respDataLength;
        setPostMore(DataLength && TotalCount ? DataLength < TotalCount : false);
        break;
      case KnowledgeBaseDataType.Questions:
        setQuestionData(data);
        DataLength = questionLength + respDataLength;
        setQuestionMore(DataLength && TotalCount ? DataLength < TotalCount : false);
        break;
      case KnowledgeBaseDataType.Bookmarks:
        setBookmarksData(data);
        DataLength = bookmarksLength + respDataLength;
        setBookmarksMore(DataLength && TotalCount ? DataLength < TotalCount : false);
        break;
    }

    setCount(TotalCount);
    // } else {
    //   //  setMasterData([]);
    //   setCount(0);
    // }
    if (showLoader) setLoading(false);
  };

  const setSearchFeedData = async (page) => {
    setLoading(true);

    let TotalCount = 0;
    let DataLength = 0;
    let posts = await getFeedsFromApi(KnowledgeBaseDataType.Posts, page);
    let questions = await getFeedsFromApi(KnowledgeBaseDataType.Questions, page);
    let newSearchData = [...posts, ...questions];
    setSearchData(newSearchData);
    TotalCount = newSearchData?.totalCount;
    DataLength = searchData?.length + newSearchData?.length;
    setSearchMore(DataLength && TotalCount ? DataLength < TotalCount : false);
    setLoading(false);
  };

  const rerender = (page, dataType) => {
    switch (dataType) {
      default:
      case KnowledgeBaseDataType.Posts:
        setFeedsData(KnowledgeBaseDataType.Posts, page);
        break;
      case KnowledgeBaseDataType.Questions:
        setFeedsData(KnowledgeBaseDataType.Questions, page);
        break;
      case KnowledgeBaseDataType.Search:
        setSearchFeedData(page);
        break;
    }
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleTabChangeIndex = (index) => {
    setTabIndex(index);
  };

  const setDetails = (id, isKnowledge) => {
    localStorage.setItem("position", window.pageYOffset);
    setDetail(id);
    showDetail(true);
    setKnowledge(isKnowledge);
  };

  if (details) {
    let path = props?.location?.pathname ? props.location?.pathname : "/home";
    // let path = 'Home';
    if (path == "/details" && knowledgeDetailsData && knowledgeDetailsData.from) {
      path = knowledgeDetailsData.from;
    }
    const detailsData = {
      id: detailId,
      isKnowledge: isKnowledge,
      from: path,
      redirected: true,
    };

    storeInEncLocalStorage("knowledgeDetailsData", JSON.stringify(detailsData));

    if (path != "/details") {
      return (
        <Redirect
          to={{
            pathname: "/details",
            state: detailsData,
          }}
        />
      );
    } else {
      window.location.reload();
    }
  }

  const Bookmarks = () => {
    return (
      <div className="card">
        <div className="card-body">
          <div className="display-row justify-space-between">
            <h6 className="card-title">Bookmarks</h6>
            <img src={images.bookmark_black} className="aside-card-icon" />
          </div>
          <hr style={{ margin: "5px 0 10px 0" }} />

          {bookmarksData.length > 0 ? (
            bookmarksData.map((bookmark) => (
              <div className="card mb-3" style={{ margin: 0 }} key={bookmark.id}>
                <div className="row g-0">
                  <div className="col-md-3">
                    {/* <img
                      src={images.login_background}
                      className=" card-img aside-card-img"
                    /> */}
                    {(bookmark.attachment_file_type !== null && bookmark.attachment !== null) || (bookmark.video_id != null && bookmark.video_id != "") ? (
                      <ShowAttachment
                        ThumbnailGcp={bookmark.thumbnail}
                        GcpVideoUrl={bookmark.VideoUrl}
                        aType={bookmark.attachment_file_type}
                        attachment={bookmark.attachment}
                        videoId={bookmark.video_id}
                        thumbnailId={bookmark.thumbnailId}
                        thumbnail={bookmark.thumbnail}
                        videoMetadata={bookmark?.VideoMetadata}
                        isFromAsideCards={true}
                      />
                    ) : null}
                  </div>
                  <div
                    className="col-md-9"
                    onClick={() => {
                      setDetails(bookmark?.knowledge_id ? bookmark.knowledge_id : bookmark.question_id, bookmark.isknowledge);
                    }}
                    style={{ cursor: "pointer" }}
                    title="View details"
                  >
                    <div className="card-body aside-card-body bookmarrk-card">
                      <h6 style={{ fontSize: "0.80rem" }}>{bookmark.title.length > 30 ? bookmark.title.substring(0, 30) + "..." : bookmark.title}</h6>
                      <p style={{ fontSize: "0.70rem" }}>
                        {bookmark.description.length > 80 ? bookmark.description.substring(0, 80) + "..." : bookmark.description}
                      </p>
                      <p className="small-card-text">
                        <span>{format(new Date(bookmark?.created_date), "MMMM dd yyyy")}</span>
                        <span style={{ fontWeight: "bold", marginLeft: "15px" }}>{bookmark.creator}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="card">
              <div className="card-body">
                <p>No bookmarks</p>
              </div>
            </div>
          )}

          <Link to="/bookmarks" className="justify-space-around">
            <h6 className="view-all-button">View all</h6>
          </Link>
        </div>
      </div>
    );
  };

  const ImageModal = () => {
    return (
      <Dialog fullScreen open={showImageModal} onClose={() => setShowImageModal(false)}>
        <IconButton
          edge="start"
          color="inherit"
          onClick={() => setShowImageModal(false)}
          aria-label="close"
          size="large"
          sx={{
            position: "absolute",
            right: 0,
            margin: "1rem",
            boxShadow: "inset 0px 0px 20px 0px var(--theme-red)",
          }}
        >
          <CloseIcon />
        </IconButton>
        <div className="d-flex justify-content-center my-auto">
          <img src={data?.BackgroundImage} alt="Knowledge base cover" style={{ width: "100vw", height: "100vh" }} />
        </div>
      </Dialog>
    );
  };

  return (
    <Main active={"knowledgeBaseId"} removeContainer={true}>
      <Loadspinner filename="KnowledgeBaseByid.js" isLoading={loading} isMiddle="false" />
      <div className="row bg-white">
        <div className="col-6"></div>
        <div className="col-2 d-flex justify-content-end">
          <div
            style={{ cursor: "pointer", fontSize: "10px" }}
            className="my-2"
            onClick={() => {
              setUploadQue(true);
            }}
          >
            <img src={images.ask_expert_active} className="header-navimg-ae" />
            <span className="header-text">Ask Questions</span>
          </div>
          {uploadQue && (
            <AskQuery
              handleModal={setUploadQue}
              knowledgeBaseId={kbId}
              askQuestionCallback={() => {
                setTabIndex(1);
                setFeedsData(KnowledgeBaseDataType.Questions, 1);
              }}
            />
          )}
        </div>
        <div className="col">
          <div className="search-bar">
            <div className="input-group">
              <input
                type="text"
                className="form-control search-input"
                value={searchText}
                placeholder="Search"
                onChange={(e) => setSearchText(e.target.value)}
                autoComplete={CommonConstants.autoCompleteInput}
              />
              <button
                className="btn search-btn"
                type="button"
                //   onClick={()=>getBookmarks()}
              >
                <img src={images.search} className="search-icons" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        {/* <img src={data?.BackgroundImage} style={{
          margin: "80px",
          height: "350px",
          width: "90%"
        }}></img> */}
        <Card sx={{ width: "100%" }} id={data?.Id} elevation={5}>
          <CardMedia
            sx={{ height: "25vh" }}
            image={data?.BackgroundImage} //event?.value[0].localUrl || event?.value[0].globalUrl
            className="card-img"
            onClick={() => setShowImageModal(true)}
          ></CardMedia>
          <CardContent>
            <div style={{ position: "relative" }}>
              <Avatar
                src={data?.ProfileImage}
                sx={{
                  width: 56,
                  height: 56,
                  position: "absolute",
                  top: "-2rem",
                }}
              />
            </div>
            <div style={{ marginLeft: "5rem" }}>
              <Typography variant="h6" component="span" style={{ fontWeight: "bold" }}>
                {data?.Name}
              </Typography>
              <div className="py-2" style={{ color: "grey" }}>
                <Typography variant="subtitle1" component={"span"} noWrap={false}>
                  {data?.Description}
                </Typography>
              </div>
            </div>
          </CardContent>
        </Card>
        <AppBar position="static" sx={{ backgroundColor: "var(--theme-red)" }}>
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="inherit"
            variant="standard"
            TabIndicatorProps={{ style: { backgroundColor: "white" } }}
          >
            <Tab style={{ fontWeight: "bolder" }} label="Posts" {...a11yProps(0)} hidden={searchText} />
            <Tab style={{ fontWeight: "bolder" }} label="Questions" {...a11yProps(1)} hidden={searchText} />
            <Tab style={{ fontWeight: "bolder" }} label="Search results" {...a11yProps(2)} hidden={!searchText} />
          </Tabs>
        </AppBar>
        <div className="row">
          <div className="col-8 d-flex justify-content-center">
            <div>
              <TabPanel value={tabIndex} index={0} dir={theme.direction} hidden={searchText}>
                <DataCards2
                  dataList={postData}
                  rerenderParentCallback={rerender}
                  ismore={isPostMore}
                  isBookmarks={false}
                  knowledgeBaseId={kbId}
                  setBookmarkClickedCallback={(val) => setBookmarkClicked(val)}
                  dataType={KnowledgeBaseDataType.Posts}
                />
              </TabPanel>
              <TabPanel value={tabIndex} index={1} dir={theme.direction} hidden={searchText}>
                <DataCards2
                  dataList={questionData}
                  rerenderParentCallback={rerender}
                  ismore={isQuestionMore}
                  isBookmarks={false}
                  knowledgeBaseId={kbId}
                  setBookmarkClickedCallback={(val) => setBookmarkClicked(val)}
                  dataType={KnowledgeBaseDataType.Questions}
                />
              </TabPanel>
              <TabPanel value={tabIndex} index={2} dir={theme.direction} hidden={!searchText}>
                <DataCards2
                  dataList={searchData}
                  rerenderParentCallback={rerender}
                  ismore={isSearchMore}
                  isBookmarks={false}
                  knowledgeBaseId={kbId}
                  setBookmarkClickedCallback={(val) => setBookmarkClicked(val)}
                  dataType={KnowledgeBaseDataType.Search}
                />
              </TabPanel>
            </div>
          </div>
          <div className="col-4 pt-3">
            <Bookmarks />
          </div>
        </div>
      </div>
      <ImageModal />
    </Main>
  );
};

export default KnowldegeBaseaId;

KnowldegeBaseaId.PropTypes = {
  location: PropTypes.object,
};
